import { ConfigType } from '../utils/requestAPI';
export type AddSymbolsDataType = {
  symbolName?: string;
  uploadSymbol: {
    url?: string;
    title?: string;
    file?: File;
  }[];
};
type GetSymbolsParamsType = {
  page?: number;
  limit?: number;
  search?: string;
};

const symbolApi = {
  addSymbols: (data: AddSymbolsDataType): ConfigType => {
    return {
      url: '/symbols',
      method: 'post',
      data: data,
    };
  },

  getSymbols: (params: GetSymbolsParamsType): ConfigType => {
    return {
      url: '/symbols',
      method: 'get',
      params,
      config: { store: { action: 'set', key: 'symbols.data' } },
    };
  },
};

export default symbolApi;
